import { render } from "./KYC.vue?vue&type=template&id=78987bd8"
import script from "./KYC.vue?vue&type=script&lang=js"
export * from "./KYC.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/admin-ui-svc/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__